/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsSlideshowClassic = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));

      // Selectors
      const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

      const $slideshowClassic = $slideshowClassicEl.flickity({
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
        pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
        draggable: true,
        imagesLoaded: true,
        autoPlay: true,
        fade: this.image_transition == 'fade' ? true : false,
        autoPlay: this.image_slideshow_speed * 1000,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 80, y2: 40,
          x3: 35
        }
      });

      // Resize flickity when the slider is settled
      $slideshowClassicEl.on('settle.flickity', function () {
        $slideshowClassicEl.flickity('resize');
      })

    },
    blockSelect: function ($section, blockId) {
      const $slider = $section.find('[data-image-slideshow]');
      const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

      $slider.flickity('select', $sliderIndex, true, true);

    },
    unload: function ($section) {

    }
  }

  /******/
})()
  ;